import * as React from "react";
// components
import RoundImage from "common/components/roundImage";
import { LinkBlock } from "common/helpers/styledMixins";
import { VingleURL } from "@vingle/wtf-sdk/url";

interface IProps {
  user: Vingle.User.ISimplifiedUser;
  width: number;
  height: number;
}

class UserProfileBox extends React.PureComponent<IProps> {
  public render() {
    const { user, width, height } = this.props;
    const roundImage = (
      <RoundImage
        width={width}
        height={height}
        imageSrc={user.profile_image_urls}
      />
    );
    const userLocation = new VingleURL.UserShow({ username: user.username });
    return <LinkBlock to={userLocation.toString()}>{roundImage}</LinkBlock>;
  }
}

export default UserProfileBox;
